import React, { useState } from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Tooltip,
  Box,
  Input,
} from "@chakra-ui/react";
import ServiceSelectNew from "../select/ServiceSelectNew";
import { useTranslation } from "react-i18next";
import {
  backgroundLight,
  buttonGreen,
  buttonGreenText,
  buttonRed,
  buttonRedText,
  buttonYellow,
  color2,
  hoverItemColor,
  newBorder,
  primary,
  primaryAlt,
  textPrimary,
  textSecondary,
  white,
} from "../../utils/colors";
import { Button, Flex, Icon, IconButton, Text } from "@chakra-ui/react";
import { FaLock, FaLockOpen, FaXmark } from "react-icons/fa6";
import TreatmentPlanSelectNew from "../select/TreatmentPlanSelectNew";
import { motion } from "framer-motion";
import {
  TbAlertCircle,
  TbAlertTriangleFilled,
  TbCircleCheckFilled,
  TbClockFilled,
} from "react-icons/tb";
import { FaCheckCircle } from "react-icons/fa";
import { Link } from "react-router-dom";
import StatusBadge from "../badges/StatusBadge";

const SelectSenderIdentityModal = ({
  data,
  sender,
  handleSenderSelect,
  addSenderIdentitiesModalOpen,
  setAddSenderIdentitiesModalOpen,
}) => {
  const { t } = useTranslation();

  // console.log("data", data);

  const statusBg = (status) => {
    if (status === "verified") {
      return buttonGreen;
    } else if (status === "pending") {
      return buttonYellow;
    } else {
      return buttonRed;
    }
  };

  const statusColor = (status) => {
    if (status === "verified") {
      return buttonGreenText;
    } else if (status === "pending") {
      return textPrimary;
    } else {
      return buttonRedText;
    }
  };

  const statusIcon = (status) => {
    if (status === "verified") {
      return <Icon as={TbCircleCheckFilled} mr="0.25rem" fontSize="0.875rem" />;
    } else if (status === "pending") {
      return <Icon as={TbClockFilled} mr="0.25rem" fontSize="0.875rem" />;
    } else {
      return (
        <Icon as={TbAlertTriangleFilled} mr="0.25rem" fontSize="0.875rem" />
      );
    }
  };
  return (
    <>
      <Modal
        isOpen={addSenderIdentitiesModalOpen}
        onClose={() => setAddSenderIdentitiesModalOpen(false)}
        isCentered
        autoFocus={false}
      >
        <ModalOverlay />
        <ModalContent borderRadius="1.5rem" w="100%" minW="600px">
          <ModalHeader p="1rem 1.5rem" borderBottom={`1px solid ${newBorder}`}>
            <Flex w="100%" align="center" justify="space-between">
              <Text fontSize="1rem" fontWeight="600" color={textPrimary}>
                {t("treatmentPlan.selectSenderIdentity")}
              </Text>
              <Flex align="center" justify="flex-end" gap="1.5rem">
                <IconButton
                  size="sm"
                  bg={backgroundLight}
                  color={textSecondary}
                  onClick={() => setAddSenderIdentitiesModalOpen(false)}
                  borderRadius="10rem"
                  _hover={{ bg: primaryAlt, color: white }}
                >
                  <Icon as={FaXmark} />
                </IconButton>
              </Flex>
            </Flex>
          </ModalHeader>

          <ModalBody p="1.5rem 1.5rem 0rem">
            <Box
              w="100%"
              as={motion.div}
              initial={{ opacity: 0 }}
              animate={{ opacity: 1, transition: 0.2 }}
            >
              {/* <Flex w="100%" align="center" justify="space-between" gap="1rem">
                <Flex align="center" w="100%">
                  <Input
                    size="md"
                    fontSize="sm"
                    placeholder={t("service.search")}
                    // value={customSearch}
                    // onChange={handleCustomSearchChange}
                    width="100%"
                    borderRadius="10rem"
                  />
                </Flex>
                <Flex align="center"></Flex>
              </Flex> */}

              <Flex w="100%" textAlign="center">
                <Text
                  fontSize="sm"
                  fontWeight="500"
                  color={textSecondary}
                  m="0 auto 1rem"
                >
                  {t("treatmentPlan.selectSenderIdentityTitle")}
                </Text>
              </Flex>

              <Box
                w="100%"
                // minH="calc(269px + 0rem)"
                bg={white}
                borderRadius="1rem"
                border={`1px solid ${newBorder}`}
                // p="1rem"
                m="0rem 0 2rem"
                // maxH="295px"
                overflowY="auto"
              >
                <Flex w="100%" h="100%" direction="column" gap="0rem">
                  {data.map((item, index) => (
                    <Flex
                      key={index}
                      w="100%"
                      h="3.5rem"
                      p="0 1rem"
                      align="center"
                      justify="space-between"
                      bg={item.email === sender.email ? primary : white}
                      color={item.email === sender.email ? white : textPrimary}
                      // border={
                      //   item.email === sender.email
                      //     ? `1px solid ${primary}`
                      //     : `1px solid ${white}`
                      // }
                      // borderRadius="1rem"
                      cursor="pointer"
                      onClick={() => handleSenderSelect(item)}
                      _hover={{
                        bg:
                          item.email === sender.email
                            ? primary
                            : hoverItemColor,
                        color:
                          item.email === sender.email ? white : textPrimary,
                      }}
                    >
                      <Flex align="center" gap="1rem">
                        <Flex align="center" gap="1rem">
                          <Text fontSize="sm" fontWeight="500">
                            {item.email}
                          </Text>
                        </Flex>

                        {item && item.isDefault && (
                          <Text fontSize="xs" color={color2} fontWeight="500">
                            {t("common.default")}
                          </Text>
                        )}
                      </Flex>
                      <Flex align="center" gap="1rem">
                        <StatusBadge
                          isSmall
                          options="senderIdentity"
                          status={item.status}
                          ml={2}
                        />

                        {/* <Button
                          size="sm"
                          // h="2.25rem"
                          minW="8rem"
                          fontSize="xs"
                          bg={statusBg(item.status)}
                          color={statusColor(item.status)}
                          borderRadius="10rem"
                        >
                          {statusIcon(item.status)}

                          {item.status === "verified"
                            ? t("status.senderIdentityVerified")
                            : item.status === "pending"
                            ? t("status.senderIdentityPending")
                            : t("status.senderIdentityUnverified")}
                        </Button> */}
                      </Flex>
                    </Flex>
                  ))}
                </Flex>
              </Box>

              <Flex
                w="100%"
                bg={white}
                borderRadius="1rem"
                m="0 0 0rem"
                // p="1rem"
                textAlign="center"
              >
                <Text
                  fontSize="sm"
                  fontWeight="500"
                  m="0 auto 0.5rem"
                  maxW="90%"
                  color={textSecondary}
                >
                  <Icon
                    as={TbAlertCircle}
                    color={primary}
                    fontSize="0.875rem"
                    position="relative"
                    top="0.125rem"
                    mr="0.125rem"
                  />
                  Please note that in order to send emails to patients from your
                  clinic email address, you need to have a verified sender
                  identity. You can verify, add, or delete sender identities in
                  the{" "}
                  <Text
                    as={Link}
                    to="/settings"
                    color={primary}
                    fontWeight="600"
                    _hover={{ textDecor: "underline", color: primaryAlt }}
                  >
                    settings
                  </Text>
                  .
                </Text>
              </Flex>

              <ModalFooter
                p="2rem 1.5rem 1.5rem"
                borderTop={`0px solid ${newBorder}`}
              >
                <Flex align="center" justify="center" w="100%" gap="1rem">
                  <Button
                    minW="6rem"
                    size="md"
                    fontSize="sm"
                    bg={backgroundLight}
                    color={textSecondary}
                    onClick={() => setAddSenderIdentitiesModalOpen(false)}
                    borderRadius="10rem"
                    _hover={{ bg: primaryAlt, color: white }}
                  >
                    {t("button.close")}
                  </Button>
                  <Button
                    minW="6rem"
                    size="md"
                    fontSize="sm"
                    bg={textPrimary}
                    color={white}
                    onClick={() => setAddSenderIdentitiesModalOpen(false)}
                    borderRadius="10rem"
                    _hover={{ bg: primaryAlt, color: white }}
                  >
                    Ok
                  </Button>
                </Flex>
              </ModalFooter>
            </Box>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
};

export default SelectSenderIdentityModal;
